import '@mod-publisher/js/richcontent/all';
import './rtd.css';
